import { Dialog as HeadlessDialog } from '@headlessui/react'
import { ReactNode, useMemo } from 'react'

import { IconClose } from '@/components/common/General/Icon'

type DialogTypes = 'default' | 'appDownload'

export type DialogProps = {
  title: string
  body: string | ReactNode
  extraBody: ReactNode
  isOpen: boolean
  dialogType?: DialogTypes
  onClose: () => void
  hasCancelButton?: boolean
  isPaddingRight?: boolean
}

export const Dialog = ({
  title,
  body,
  extraBody,
  isOpen,
  dialogType = 'default',
  onClose,
  hasCancelButton = true,
  isPaddingRight = true,
}: DialogProps) => {
  const bodyClassName = useMemo(() => {
    const commonClassName = 'mb-24 text-center'
    if (dialogType === 'appDownload') {
      return `${commonClassName} text-sm text-black`
    }
    return `${commonClassName} text-xs font-medium text-thirdly`
  }, [dialogType])

  return (
    <HeadlessDialog open={isOpen} onClose={onClose} className="relative z-50">
      <div className="fixed inset-0 bg-black/50" aria-hidden="true" />
      <div className="flex fixed inset-0 justify-center items-center p-16">
        <HeadlessDialog.Panel className="relative mx-auto w-full max-w-[375px] bg-primary rounded-2xl">
          <div className={`px-16 pt-32 pb-16 ${!isPaddingRight && 'pr-0'}`}>
            <HeadlessDialog.Title className="mb-8 text-xl font-bold text-center text-black">
              {title}
            </HeadlessDialog.Title>
            <p className={bodyClassName}>{body}</p>
            {extraBody}
          </div>
          {hasCancelButton ? (
            <button
              className="flex justify-center items-center p-16  w-full border-t border-ui-3  border-solid"
              onClick={onClose}
            >
              <span className="text-sm font-bold text-center text-black cancel-gradation-text">
                キャンセル
              </span>
            </button>
          ) : (
            <button onClick={onClose} className="absolute top-16 right-16">
              <IconClose width={24} height={24} />
            </button>
          )}
        </HeadlessDialog.Panel>
      </div>
    </HeadlessDialog>
  )
}
